"use client";

import Image from "next/image";

export default function Terms() {
  return (
    <main className="w-full mx-auto py-[100px] font-albert-sans flex flex-row justify-center bg-[#141416]">
      <div className="lg:max-w-[669px] w-[90%] p-9 flex flex-col items-center gap-y-12 border border-[#333]">
        <div
          className="cursor-pointer"
          onClick={() => {
            window.open("https://spheron.network");
          }}
        >
          <Image
            src="/spheron-logo.svg"
            alt="spheron logo"
            width="100"
            height="34"
          />
        </div>
        <div className="flex flex-col gap-y-2">
          <p className="text-2xl uppercase text-center">Genesis drop Terms and Conditions</p>
          <p className="text-center">Last Updated on 24/01/2025</p>
          <div className="text-base font-[400]">
            Welcome to the DCloud Network Ltd (the "Company"). These Terms and
            Conditions (these "Terms") is of for the Company&apos;s Genesis drop claim or
            other participating project Genesis drop claim (the "Genesis drop") organized
            by the Company and/or its subsidiaries and affiliates, as the case
            may be, from time to time (collectively, ("we" or "us" or "our")
            from Company&apos;s website at https://spheron.network. These terms and
            conditions are a binding contract between you, an individual user
            ("you" "your" or "users") and the Company. The Genesis drop, and your
            participation in it, is a service as defined under this Terms.
            <br />
            <br />
            These Terms govern your ability to participate in the Genesis drop in
            respect of Company&apos;s Genesis drop or other participating projects which
            may be assisted by the Company. In these Terms, "Genesis drop" shall mean
            the Company&apos;s Genesis drop or other participating project which are the
            native digital asset with utility functions on their respective
            protocol/platform, which are completely claimable without any
            vesting period. Please read these Terms carefully, as they include
            important information about your legal rights. By participating in
            the Genesis drop and/or claiming any corresponding Genesis drop, you are
            agreeing to these Terms. If you do not understand or agree to these
            Terms, please do not participate in the Genesis drop.
            <br />
            <br />
            BY PARTICIPATING IN THE GENESIS DROP, INCLUDING BUT NOT LIMITED TO BY
            ENTERING A WALLET PURSUANT TO THE TERMS AND PROCESSES DESCRIBED
            HEREIN, PARTICIPANT ACKNOWLEDGES THAT THEY HAVE READ, UNDERSTOOD,
            AND AGREED TO THESE GENESIS DROP TERMS AND CONDITIONS IN THEIR ENTIRETY.
            THE PARTICIPANT IS RESPONSIBLE FOR MAKING ITS OWN DECISION IN
            RESPECT OF ITS PARTICIPATION IN THE GENESIS DROP AND ANY RECEIPT OF
            GENESIS DROP. ANY PARTICIPATION IN THE GENESIS DROP IS SOLELY AT THE
            PARTICIPANT&apos;S OWN RISK AND IT IS THE PARTICIPANT&apos;S SOLE
            RESPONSIBILITY TO SEEK APPROPRIATE PROFESSIONAL, LEGAL, TAX, AND
            OTHER ADVICE IN RESPECT OF THE GENESIS DROP AND ANY RECEIPT OF THE
            GENESIS DROP PRIOR TO PARTICIPATING IN THE GENESIS DROP AND PRIOR TO RECEIVING
            ANY GENESIS DROP.
            <br />
            <br />
            BY PARTICIPATING IN THE GENESIS DROP, THE PARTICIPANT EXPRESSLY
            ACKNOWLEDGES AND ASSUMES ALL RISKS RELATED THERETO, INCLUDING
            (WITHOUT LIMITATION) THE RISKS SET OUT BELOW. IN NO EVENT SHALL THE
            COMPANY OR ANY COMPANY PERSON BE HELD LIABLE IN CONNECTION WITH OR
            FOR ANY CLAIMS, LOSSES, DAMAGES, OR OTHER LIABILITIES, WHETHER IN
            CONTRACT, TORT, OR OTHERWISE, ARISING OUT OF OR IN CONNECTION WITH
            THE GENESIS DROP OR THE RECEIPT OF ANY GENESIS DROP.
            <br />
            <br />
            THE COMPANY DOES NOT TAKE ANY RESPONSIBILITY FOR THE PARTICIPATION
            BY ANY PARTICIPANT IN THE GENESIS DROP. THE COMPANY DOES NOT PROVIDE ANY
            RECOMMENDATION OR ADVICE IN RESPECT OF THE GENESIS DROP.. EACH
            PARTICIPANT PARTICIPATES IN THE GENESIS DROP AT ITS OWN RISK AND RECEIVES
            GENESIS DROP AT ITS OWN RISK.
            <br />
            <br />
            <div className="pl-3">
              <b>1. INTERPRETATIONS</b>
              <br />
              <br />
              <b>1.1 Modifications:</b> We reserve the right to change or modify
              these Terms at any time and at our sole discretion by posting a
              notification on our website. Any changes to or modifications to
              these Terms will be in effect as of the "Last Updated on" at the
              top of this Terms. The updated Terms will be effective as of the
              time of posting of such updated Terms. Your continued access or
              participation in the Genesis drop after the modifications have become
              effective will be deemed your acceptance of the modified Terms.
              <br />
              <br />
              <b>1.2 Headings:</b> The headings and sub-headings in the Terms
              are for ease of reference only and are not to be taken into
              account in the construction or interpretation of any provision or
              provisions to which they refer.
              <br />
              <br />
              <b>1.3 Extended meaning:</b>
              Unless otherwise specified in these Terms, words importing the
              singular include the plural and vice versa and words importing
              gender include all genders. The word “include”, “includes” or
              “including” will be interpreted on an inclusive basis and be
              deemed to be followed by the words “without limitation”. The
              language in these Terms will be interpreted as to its fair
              meaning, and not strictly for or against any party.
              <br />
              <br />
              <b>2. ACKNOWLEDGMENT</b>
              <br />
              The user acknowledges that we may check your background and
              identity, in our sole and absolute discretion, in connection with
              certain use of the website. You hereby authorise us to, directly
              or indirectly or through third parties, make any enquiries and
              conduct any investigation we consider necessary or helpful to
              verify your identity and to take any actions we deem necessary or
              helpful based on the results of such inquiries and investigations.
              You further authorize any and all third parties to which such
              inquiries or investigations may be directed to fully respond to
              such inquiries or investigations. You acknowledge and agree that
              we may, in our sole discretion, deny any rights to use the
              website, the platform. You further acknowledge and agree that we
              will not be liable to you for any liability or other losses
              arising from any inquiries or investigations arising under this
              section.
              <br />
              <br />
              <b>3. GENERAL AGREEMENT AND REPRESENTATIONS</b>
              <br />
              You represent and warrant that all information provided during the
              Genesis drop process is true, accurate, and complete.
              <br />
              <br />
              3.1. You agree and acknowledge that (a) you are solely responsible
              and liable for all taxes due in connection with your participation
              in the Genesis drop; and (b) you should consult a tax advisor with
              respect to the tax treatment of Genesis drop in your jurisdiction.
              <br />
              <br />
              3.2. You agree and acknowledge that you are responsible for
              complying with all applicable laws of the jurisdiction in which
              you reside or in which you are participating in the Genesis drop and
              claiming Genesis drop.
              <br />
              <br />
              3.3. You agree that you are not (i) a citizen and resident of
              Restricted Jurisdiction (as defined in the below under 3.3.1);
              (ii) directly or indirectly acting on behalf of citizen and
              resident of Restricted Jurisdiction; and (iii) located in or
              accessing the Services from a Restricted Jurisdiction. You agree
              that you will not use a virtual private network (“VPN”) or similar
              tool to circumvent any geo-blocking and/or other restrictions that
              we have implemented in connection with the Genesis drop. Any such
              deliberate circumvention, or attempted circumvention, of our
              controls may permanently disqualify you from participation in the
              Genesis drop, as determined in our discretion.
              <br />
              <br />
              3.3.1. Restricted Jurisdictions: Algeria, Bolivia, Morocco, Nepal,
              Pakistan, Vietnam, Afghanistan, Canada, China, Ivory Coast, Cuba,
              Iraq, Iran, Liberia, North Korea, Syria, Sudan, South Sudan,
              Zimbabwe, Antigua, American Samoa, Guam, Northern Mariana Islands,
              Puerto Rico, United States (and its territories), United States
              Minor Outlying Islands, US Virgin Islands, Ukraine, Belarus,
              Albania, Burma, Central African Republic, Democratic Republic of
              Congo, Lybia, Somalia, Yemen, and Thailand ("Restricted
              Jurisdictions"). By accessing or using the website, you represent
              and warrant that you are not located in, under the control of, or
              a resident or national of any Restricted Jurisdiction, including
              but not limited to countries sanctioned by the United Nations, the
              United States, the European Union, or any other relevant
              governmental authority. In addition, you represent to us that you
              are (1) not subject to sanctions or otherwise designated on any
              list of prohibited or restricted parties, including but not
              limited to the lists maintained by the United Nations Security
              Council, the U.S. Government (i.e., the US Department of the
              Treasury&apos;s Office of Foreign Assets Control ("OFAC"), the
              Specially Designated Nationals List and Foreign Sanctions Evaders
              List of the U.S. Department of Treasury and the Entity List of the
              U.S. Department of Commerce), the European Union or its Member
              States, the United Kingdom, or other applicable government
              authority and (2) not located in any country subject to a
              comprehensive sanctions program implemented by the United States.
              <br />
              <br />
              3.4. By using the website and participating in the Genesis drop, you
              agree and acknowledge that:
              <br />
              <br />
              3.4.1. The Company may exclude IP Addresses from the Genesis drop if it
              is detected by geo-location controls that persons participating or
              attempting to participate in the Genesis drop as mentioned in clause
              3.3 above; or any other jurisdiction where Genesis drop or distribution
              of crypto-tokens are prohibited, restricted or unauthorized in any
              form of manner, whether in full or in part, under the laws,
              regulatory requirements or rules in that jurisdiction
              (collectively, “Prohibited Jurisdictions”). You agree and
              understand that the Prohibited Jurisdictions are subject to change
              at the Company&apos;s sole discretion without notice.
              <br />
              <br />
              3.4.2. The Company may take additional measures to ensure the
              restrictions set out in the Genesis drop Terms and/or compliance with
              applicable law and regulations, including implementing additional
              geo-location, proxy detection or screening control to prevent
              access to the Genesis drop by persons that may be Prohibited persons or
              located in Prohibited Jurisdictions or restricting the use of any
              technology by participants that may circumvent or attempt to
              circumvent the restrictions specified in the Genesis drop Terms.
              <br />
              <br />
              3.4.3. The Company reserves the right, at any time, in its sole
              discretion, to block a Participant&apos;s access to the Genesis drop and to
              disqualify from the Genesis drop any person or user we believe to be in
              actual or potential breach of these Terms.
              <br />
              <br />
              3.5. You agree and acknowledge that the Company reserves the right
              to require additional information from you and to enter, use, or
              share such information into or with a third party service
              provider, and its systems, tools, or functionalities, as the
              Company deems appropriate in its sole discretion, including to
              reduce the risks of money laundering, terrorist financing,
              sanctions violations, or other potentially illicit activity, or as
              otherwise necessary to address laws and regulations that may be
              relevant to the Genesis drop. You agree to provide complete and
              accurate information in response to any such requests. You agree
              and acknowledge that the Company is not responsible and cannot be
              held liable for any losses, expenses, or delays resulting from
              inaccurate or incomplete information, and you agree to assume full
              responsibility for any and all risks associated therewith.
              <br />
              <br />
              3.6. You agree and acknowledge that your participation in the
              Genesis drop and claim of Genesis drop does not require or involve any form
              of purchase, payment, or tangible consideration from or to us, nor
              otherwise require or involve any acceptance of value by us from
              you. You agree and acknowledge that you (a) lawfully may receive
              Genesis drop for free, or as per a particular ratio, via the Genesis drop
              (other than gas fees or applicable taxes, if any, that may be due
              to third parties), (b) were not promised the Genesis drop(whether via
              the Genesis drop or otherwise); and (c) took no action in anticipation
              of, or in reliance on, receiving the Genesis drop, the occurrence of an
              Genesis drop , or potential participation in any Genesis drop.
              <br />
              <br />
              3.7. Your eligibility to receive Genesis drop or participate in the
              Genesis drop is subject to our sole discretion. The Genesis drop shall be
              conducted during a specified period, as determined by the Company
              in its sole discretion and announced on its website. Participants
              must follow the instructions set forth in any Genesis drop announcement
              and/or such other instructions as may be provided by the Company
              from time to time to participate in the Genesis drop. The number of
              Genesis drop allocated to each Participant will be determined by the
              Company or other participating project, based on its internal
              parameters and calculations, and such allocation may vary among
              Participants.
              <br />
              <br />
              3.8. You agree that you are the legal owner of the wallet address
              that you use to access or participate in the Genesis drop, and will not
              sell, assign, or transfer control of such address or the Genesis drop
              to third parties to circumvent any lock-up period for Genesis drop or
              to knowingly redistribute Genesis drop to a wallet address that would
              violate these Terms. Failure to provide and/or connect the wallet
              address may result in the forfeiture of Genesis drop. There may be
              technical limitations, delays, and/or transaction fees due or
              payable to third parties, such as gas fees, to receive and/or
              claim Genesis drop through your wallet address.
              <br />
              <br />
              3.9. By using a wallet, you agree that you are using the wallet in
              accordance with any terms and conditions of an applicable
              third-party provider of such wallet. Wallet addresses are not
              maintained or supported by, or associated or affiliated with, the
              Company. When you interact with the Genesis drop or other services, as
              between the Company and you, you retain control over your wallet
              address at all times. We do not control digital assets, including
              the Genesis drop, in your wallet, and we accept no responsibility or
              liability to you in connection with your use of a wallet. We make
              no representations or warranties regarding how the Genesis drop or
              other services will operate with, or be compatible with, any
              specific wallet. The private keys necessary to access and/or
              transfer the digital assets, including the Genesis drop, held in a
              wallet are not known or held by the Company. Any third party that
              may gain access to Participant&apos;s login credential, private key, or
              third-party cloud or storage mechanism for such information may be
              able to misappropriate Genesis drop and/or other digital assets held by
              Participant. The Company has no ability to help you access or
              recover your private key and/or seed phrase for your wallet. As
              between you and the Company, you are solely responsible for
              maintaining the confidentiality of your private key, and solely
              you are responsible for any transaction signed with your private
              key. The Company is not responsible for any loss associated with
              the Participant&apos;s private key, wallet address, vault, or other
              storage mechanism.
              <br />
              <br />
              3.10. You agree and acknowledge that claiming the Genesis drop may
              require interaction with, reliance on, or an integration with
              third-party products or services (e.g., a wallet or a network or
              blockchain) that we do not control. In the event that you are
              unable to access such products, services, or integrations, or if
              they fail for any reason, and you are unable to participate in the
              Genesis drop or claim Genesis drop as a result, you will have no recourse or
              claim against us or any Company person; and neither we nor any
              Company person bear(s) any responsibility or liability to you.
              <br />
              <br />
              3.11. You agree and acknowledge that your participation in the
              Genesis drop is at your own risk. You agree and acknowledge that you
              have carefully reviewed, read, and understood these Terms.
              <br />
              <br />
              3.12. You agree that you shall defend, indemnify, and hold the
              Company and Company person(s) harmless from and against any and
              all claims, actions, proceedings, investigations, demands, suits,
              costs, damages, losses, liabilities and expenses (including
              attorneys&apos; fees and costs, and fines or penalties imposed by any
              regulatory authority) incurred by Company person(s) arising out of
              or in connection with: (a) your use of, or conduct in connection
              with, the Genesis drop; (b) your breach or our enforcement of these
              Genesis drop Terms, or (c) your violation of any applicable law,
              regulation, or rights of any third party. If you are obligated to
              indemnify any Company person hereunder, then you agree that the
              Company (or, at its discretion, the applicable Company persons)
              will have the right, in its sole discretion, to control any action
              or proceedings and to determine whether the Company wishes to
              settle, and if so, on what terms, and you agree to fully cooperate
              with the Company in the defence or settlement of such claim. Your
              obligations under this indemnification provision will continue
              even after these Genesis drop Terms have expired or been terminated.
              <br />
              <br />
              3.13. You represent and warrant that if you are an individual,
              that you are at least 18 (eighteen) years old and have capacity to
              form a binding contract under applicable laws.
              <br />
              <br />
              3.14. You represent and warrant that if you are a corporation,
              legal entity or other organization, then you have full power,
              authority and your entity is validly existing under the applicable
              laws to enter into these Terms. You agree and acknowledge that
              following activities are specifically prohibited when using this
              website or any of the services:
              <br />
              <br />
              3.14.1. Any use in violation of any valid law, including but not
              limited to, regulations for financial services, money laundering,
              economic sanctions, consumer protection, competition law,
              protection against discrimination or misleading advertising and,
              in particular, any violation against copyrights, patents,
              trademarks, trade secrets and other property rights.
              <br />
              <br />
              3.14.2. Concealing your identity such as by using a proxy server
              or by using a post box as an address for the purpose of carrying
              out illegal, fraudulent, or other prohibited activities.
              <br />
              <br />
              3.14.3. Enabling (including attempting to enable) the spread of
              viruses, trojans, malware, worms or other program processes that
              damage, disrupt, misuse, impair, secretly intercept, destroy or
              disable (operating) systems, data or information, or granting
              unauthorized access to systems, data, information or the services.
              <br />
              <br />
              3.14.4. Using an automatic device or a mechanical or manual method
              for monitoring or replicating the services, the website or these
              Terms without our prior written permission.
              <br />
              <br />
              3.14.5. engaging in any activity that seeks to defraud us or any
              other person or entity, including providing any false, inaccurate,
              or misleading information in order to unlawfully obtain the
              property of another.
              <br />
              <br />
              3.14.6. harvest or collect email addresses or other contact
              information of other participants by electronic or other means for
              the purposes of sending unsolicited emails or other unsolicited
              communications; or further or promote any criminal activity or
              enterprise or provide instructional information about illegal
              activities.
              <br />
              <br />
              3.14.7. Encouraging or enabling any other individual or entity to
              do any of the foregoing or otherwise violate the Terms.
              <br />
              <br />
              3.15. By accessing and using these Terms, you represent and
              warrant that you understand the inherent risks associated with
              using cryptographic and blockchain-based systems, and that you
              have a working knowledge of the usage and intricacies of digital
              assets. You further understand that the markets for digital assets
              are highly volatile due to various factors, including adoption,
              speculation, technology, security, and regulation. You acknowledge
              and accept that the cost and speed of transacting with
              cryptographic and blockchain-based systems are variable and may
              increase dramatically at any time. You further acknowledge and
              accept the risk of losing some or all of your digital assets, you
              may suffer loss due to the fluctuation of prices of Genesis drop, and,
              especially in expert modes, experience significant price slippage
              and cost. You also understand that legislative and regulatory
              changes or actions may adversely affect the usage,
              transferability, transactability and accessibility of digital
              assets, bridging, the protocol, or other parts of the service. You
              acknowledge that we are not responsible for any risks associated
              with your use of the services, and cannot be held liable for any
              resulting losses that you experience while accessing or using the
              services.
              <br />
              <br />
              3.16. These Terms contain the entire agreement between you and the
              Company regarding the Genesis drop and supersede all prior and
              contemporaneous oral and written agreements, memoranda,
              understandings and undertakings between the parties regarding the
              Genesis drop.
              <br />
              <br />
              3.17. If any term, clause, or provision of these Terms is held to
              be illegal, invalid, void, or unenforceable (in whole or in part),
              then such term, clause, or provision shall be severable from the
              Terms without affecting the validity or enforceability of any
              remaining part of that term, clause, or provision, or any other
              term, clause, or provision in the Terms, which will otherwise
              remain in full force and effect. Any invalid or unenforceable
              provisions will be interpreted to affect the intent of the
              original provisions. If such construction is not possible, the
              invalid or unenforceable provision will be severed from the Terms,
              but the rest of the Terms will remain in full force and effect.
              <br />
              <br />
              3.18. These Terms are governed by the laws of the British Virgin
              Islands, without regard to conflict of law rules or principles
              (whether of the British Virgin Islands or any other jurisdiction)
              that would cause the application of the laws of any other
              jurisdiction. Any dispute arising out of or related to these
              Terms, as well as any issue on its validity and existence, shall
              be referred to and finally resolved by arbitration administered by
              the British Virgin Islands International Arbitration Centre (BVI
              IAC) Rules in accordance with the BVI IAC Rules for the time being
              in force. The seat of the arbitration shall be the British Virgin
              Islands. The Tribunal shall consist of 1 arbitrator, appointed by
              the Company. The language of the arbitration shall be English. You
              hereby waive all rights to participate in any class action lawsuit
              or class wide arbitration against the Company or its members,
              directors, officers or stakeholders.
              <br />
              <br />
              3.19. You may not assign or transfer all or part of its rights or
              obligations under these Terms without the prior written consent of
              the Company. The Company may refuse to recognise any such
              assignment, transfer or any other transaction resembling such. The
              Company may assign, as it sees fit and in its full discretion, any
              of its rights, obligations and duties under these Terms.
              <br />
              <br />
              3.20. The Company&apos;s failure or delay to exercise or enforce any
              right or provision of these Terms will not operate as a waiver of
              such right or provision, nor will any single or partial exercise
              of any right or remedy preclude any other or further exercise
              thereof or the exercise of any other right or remedy. Any
              provision in these Terms may be waived by written and signed
              consent of the Company. A waiver of any provision or terms shall
              not be deemed a waiver of any breach of the provision or term, or
              any other provision or term.
              <br />
              <br />
              3.21. You may contact us regarding these Terms by e-mail at
              info@spheron.network
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
